import { useCallback } from 'react';

import { useSubmitOrderUsingPaymentMethodCardMutation } from '../../graphql/Checkout.generated';
import {
  type CheckoutInput,
  processSubmitResponse,
  type SubmitWithPaymentMethodCardResponse,
  VALIDATION_ERROR,
} from './common';

/**
 * Uses a {paymentMethodCardId} to submit an order.
 */
export function useSubmitOrderUsingPaymentMethodCard() {
  const [response, mutation] = useSubmitOrderUsingPaymentMethodCardMutation();

  const result = response.data?.submitOrderUsingPaymentMethodCard;
  const isSubmittingOrder = response.fetching;

  const rewardFailureCode =
    result?.__typename === 'RewardNotValidated'
      ? result.failureCode
      : undefined;

  const submitOrderMutation = useCallback(
    async (input: CheckoutInput) => {
      if (!input.paymentMethodId) return VALIDATION_ERROR;

      const submitResponse = await mutation({
        input: {
          paymentMethodCardId: input.paymentMethodId,
          orderId: input.orderId,
          wantedTime: input.wantedTime,
          useCredit: input.useCredit,
          pickupTip: input.pickupTip,
          dropoffLocationId: input.dropoffLocationId,
          contactNumber: input.contactNumber,
          includeUtensils: input.includeUtensils,
          deliveryOrderDetail: input.deliveryOrderDetail,
        },
      });

      return processSubmitResponse(
        submitResponse as SubmitWithPaymentMethodCardResponse,
      );
    },
    [mutation],
  );

  return {
    isSubmittingOrder,
    rewardFailureCode,
    submitOrderMutation,
  };
}
